import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Observable } from 'rxjs';
import { DevExFileUploaderComponent } from '../../../devExtreme/src/devFileUploader/devFileUploader.component';
import { ComponentStyle, IAbcComponent } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { FileUploaderStyle, IFileUploader, UploadMethod, UploadMode, UploadValidationStatus } from './abcFileUploader';

@Component({
  selector: 'abcFileUploader',
  template: '<ng-template #abcFileUploader></ng-template>',
})
export class AbcFileUploaderComponent implements IAbcComponent, OnInit, AfterViewInit, OnDestroy {
  @ViewChild('abcFileUploader', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Input('id') attrId: string;
  @Input('accept') accept: string;
  @Input() style: ComponentStyle = ComponentStyle.DevExpress;
  @Output() onFileUploaded = new EventEmitter();
  @Output() onImgUploaded = new EventEmitter();

  private _uploadMode: UploadMode;
  private _height: string | number;
  private _width: string | number;
  private _activeStateEnabled: boolean;
  private _class: string;
  private _value: any;
  private _selectButtonText: string;
  private _labelText: string;
  private _allowCanceling: boolean;
  private _chunkSize: number;
  private _disabled: boolean;
  private _focusStateEnabled: boolean;
  private _hoverStateEnabled: boolean;
  private _isValid: boolean;
  private _maxFileSize: number;
  private _minFileSize: number;
  private _multiple: boolean;
  private _name: string;
  private _invalidFileExtensionMessage: string;
  private _invalidMaxFileSizeMessage: string;
  private _invalidMinFileSizeMessage: string;
  private _readOnly: boolean;
  private _readyToUploadMessage: string;
  private _rtlEnabled: false;
  private _showFileList: boolean;
  private _tabIndex: number;
  private _uploadButtonText: string;
  private _uploadedMessage: string;
  private _uploadFailedMessage: string;
  private _visible: boolean;
  private _uploadUrl: string;
  private _uploadMethod: UploadMethod;
  private _validationStatus: UploadValidationStatus;
  private _dialogTrigger: string;
  private _dropZone: string;
  private _allowedFileExtensions: string[];
  private _showAvatar: boolean;

  @Input()
  get dialogTrigger() {
    return this._dialogTrigger;
  }
  set dialogTrigger(data) {
    if (this.componentRef) {
      this.componentRef.dialogTrigger = data;
    }
    this._dialogTrigger = data;
  }

  @Input()
  get dropZone() {
    return this._dropZone;
  }
  set dropZone(data) {
    if (this.componentRef) {
      this.componentRef.dropZone = data;
    }
    this._dropZone = data;
  }

  @Input()
  get showAvatar() {
    return this._showAvatar;
  }
  set showAvatar(data) {
    if (this.componentRef) {
      this.componentRef.showAvatar = data;
    }
    this._showAvatar = data;
  }

  @Input()
  get allowedFileExtensions() {
    return this._allowedFileExtensions;
  }
  set allowedFileExtensions(data) {
    if (this.componentRef) {
      this.componentRef.allowedFileExtensions = data;
    }
    this._allowedFileExtensions = data;
  }

  @Input()
  get height() {
    return this._height;
  }
  set height(data) {
    if (this.componentRef) {
      this.componentRef.height = data;
    }
    this._height = data;
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data) {
    if (this.componentRef) {
      this.componentRef.width = data;
    }
    this._width = data;
  }

  @Input()
  get chunkSize() {
    return this._chunkSize;
  }
  set chunkSize(data) {
    if (this.componentRef) {
      this.componentRef.chunkSize = data;
    }
    this._chunkSize = data;
  }

  @Input()
  get value() {
    return this._value;
  }
  set value(data) {
    if (this.componentRef) {
      this.componentRef.value = data;
    }
    this._value = data;
  }

  @Input()
  get uploadMethod() {
    return this._uploadMethod;
  }
  set uploadMethod(data) {
    if (this.componentRef) {
      this.componentRef.uploadMethod = data;
    }
    this._uploadMethod = data;
  }

  @Input()
  get validationStatus() {
    return this._validationStatus;
  }
  set validationStatus(data) {
    if (this.componentRef) {
      this.componentRef.validationStatus = data;
    }
    this._validationStatus = data;
  }

  @Input()
  get tabIndex() {
    return this._tabIndex;
  }
  set tabIndex(data) {
    if (this.componentRef) {
      this.componentRef.tabIndex = data;
    }
    this._tabIndex = data;
  }

  @Input()
  get uploadUrl() {
    return this._uploadUrl;
  }
  set uploadUrl(data) {
    if (this.componentRef) {
      this.componentRef.uploadUrl = data;
    }
    this._uploadUrl = data;
  }

  @Input()
  get uploadedMessage() {
    return this._uploadedMessage;
  }
  set uploadedMessage(data) {
    if (this.componentRef) {
      this.componentRef.uploadedMessage = data;
    }
    this._uploadedMessage = data;
  }

  @Input()
  get uploadFailedMessage() {
    return this._uploadFailedMessage;
  }
  set uploadFailedMessage(data) {
    if (this.componentRef) {
      this.componentRef.uploadFailedMessage = data;
    }
    this._uploadFailedMessage = data;
  }

  @Input()
  get uploadButtonText() {
    return this._uploadButtonText;
  }
  set uploadButtonText(data) {
    if (this.componentRef) {
      this.componentRef.uploadButtonText = data;
    }
    this._uploadButtonText = data;
  }

  @Input()
  get multiple() {
    return this._multiple;
  }
  set multiple(data) {
    if (this.componentRef) {
      this.componentRef.multiple = data;
    }
    this._multiple = data;
  }

  @Input()
  get name() {
    return this._name;
  }
  set name(data) {
    if (this.componentRef) {
      this.componentRef.name = data;
    }
    this._name = data;
  }
  @Input()
  get readOnly() {
    return this._readOnly;
  }
  set readOnly(data) {
    if (this.componentRef) {
      this.componentRef.readOnly = data;
    }
    this._readOnly = data;
  }

  @Input()
  get showFileList() {
    return this._showFileList;
  }
  set showFileList(data) {
    if (this.componentRef) {
      this.componentRef.showFileList = data;
    }
    this._showFileList = data;
  }

  @Input()
  get readyToUploadMessage() {
    return this._readyToUploadMessage;
  }
  set readyToUploadMessage(data) {
    if (this.componentRef) {
      this.componentRef.readyToUploadMessage = data;
    }
    this._readyToUploadMessage = data;
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data) {
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
    this._rtlEnabled = data;
  }
  @Input()
  get invalidFileExtensionMessage() {
    return this._invalidFileExtensionMessage;
  }
  set invalidFileExtensionMessage(data) {
    if (this.componentRef) {
      this.componentRef.invalidFileExtensionMessage = data;
    }
    this._invalidFileExtensionMessage = data;
  }
  @Input()
  get invalidMaxFileSizeMessage() {
    return this._invalidMaxFileSizeMessage;
  }
  set invalidMaxFileSizeMessage(data) {
    if (this.componentRef) {
      this.componentRef.invalidMaxFileSizeMessage = data;
    }
    this._invalidMaxFileSizeMessage = data;
  }
  @Input()
  get invalidMinFileSizeMessage() {
    return this._invalidMinFileSizeMessage;
  }
  set invalidMinFileSizeMessage(data) {
    if (this.componentRef) {
      this.componentRef.invalidMinFileSizeMessage = data;
    }
    this._invalidMinFileSizeMessage = data;
  }

  @Input()
  get maxFileSize() {
    return this._maxFileSize;
  }
  set maxFileSize(data) {
    if (this.componentRef) {
      this.componentRef.maxFileSize = data;
    }
    this._maxFileSize = data;
  }

  @Input()
  get minFileSize() {
    return this._minFileSize;
  }
  set minFileSize(data) {
    if (this.componentRef) {
      this.componentRef.minFileSize = data;
    }
    this._minFileSize = data;
  }

  @Input()
  get activeStateEnabled() {
    return this._activeStateEnabled;
  }
  set activeStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.activeStateEnabled = data;
    }
    this._activeStateEnabled = data;
  }

  @Input()
  get isValid() {
    return this._isValid;
  }
  set isValid(data) {
    if (this.componentRef) {
      this.componentRef.isValid = data;
    }
    this._isValid = data;
  }

  @Input()
  get hoverStateEnabled() {
    return this._hoverStateEnabled;
  }
  set hoverStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = data;
    }
    this._hoverStateEnabled = data;
  }

  @Input()
  get focusStateEnabled() {
    return this._focusStateEnabled;
  }
  set focusStateEnabled(data) {
    if (this.componentRef) {
      this.componentRef.focusStateEnabled = data;
    }
    this._focusStateEnabled = data;
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data) {
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
    this._disabled = data;
  }

  @Input()
  get allowCanceling() {
    return this._allowCanceling;
  }
  set allowCanceling(data) {
    if (this.componentRef) {
      this.componentRef.allowCanceling = data;
    }
    this._allowCanceling = data;
  }

  @Input()
  get class() {
    return this._class;
  }
  set class(data) {
    if (this.componentRef) {
      this.componentRef.class = data;
    }
    this._class = data;
  }

  @Input()
  get selectButtonText() {
    return this._selectButtonText;
  }
  set selectButtonText(data) {
    if (this.componentRef) {
      this.componentRef.selectButtonText = data;
    }
    this._selectButtonText = data;
  }

  @Input()
  get labelText() {
    return this._labelText;
  }
  set labelText(data) {
    if (this.componentRef) {
      this.componentRef.labelText = data;
    }
    this._labelText = data;
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data) {
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
    this._visible = data;
  }
  @Input()
  get uploadMode() {
    return this._uploadMode;
  }
  set uploadMode(data) {
    if (this.componentRef) {
      this.componentRef.uploadMode = data;
    }
    this._uploadMode = data;
  }

  fileUploaderStyle: FileUploaderStyle;
  htmlAttributes: IFileUploader;
  private componentRef;
  private eventListener = [];
  get id(): string {
    return this.componentRef.id;
  }

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
  }

  ngOnInit() {
    this.setFileUploaderAttributesIfAvailable();
    this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit() {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.abcComponentService.removeInstance(this);
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExFileUploaderComponent,
            this.viewContainerRef
          ).componentRef.instance;
          break;
        }
      }
      if (this.htmlAttributes.id) this.componentRef.id = this.htmlAttributes.id;
      if (this.htmlAttributes.selectButtonText)
        this.componentRef.selectButtonText = this.htmlAttributes.selectButtonText;
      if (this.htmlAttributes.labelText) this.componentRef.labelText = this.htmlAttributes.labelText;
      if (this.htmlAttributes.accept) this.componentRef.accept = this.htmlAttributes.accept;
      if (this.htmlAttributes.uploadMode) this.componentRef.uploadMode = this.htmlAttributes.uploadMode;
      this.componentRef.rtlEnabled = this.rtlEnabled;
      if (this.showAvatar) this.componentRef.showAvatar = this.showAvatar;
      if (this.htmlAttributes.visible) this.componentRef.visible = this.visible;
      if (this.htmlAttributes.value) this.componentRef.value = this.value;
      if (this.htmlAttributes.showFileList) this.componentRef.showFileList = this.htmlAttributes.showFileList;
      if (this.htmlAttributes.dropZone) this.componentRef.dropZone = this.htmlAttributes.dropZone;
      if (this.htmlAttributes.allowedFileExtensions)
        this.componentRef.allowedFileExtensions = this.htmlAttributes.allowedFileExtensions;
      if (this.htmlAttributes.dialogTrigger) this.componentRef.dialogTrigger = this.htmlAttributes.dialogTrigger;

      this.componentRef.onImgUploaded.subscribe((ev) => {
        this.imgUploaded(ev);
      });
      this.componentRef.onFileUploaded.subscribe((ev) => {
        this.fileUploaded(ev);
      });

      this.componentRef.setFileUploaderStyle(this.htmlAttributes.setFileUploaderStyle());
      observer.next(this.componentRef);
    });
    return observable;
  }

  setFileUploaderAttributesIfAvailable() {
    if (this.attrId) {
      const style: FileUploaderStyle = {
        height: this.height ? this.height : 25,
        width: this.width ? this.width : '100%',
      };
      this.htmlAttributes = {
        id: this.attrId,
        class: this.class,
        selectButtonText: this.selectButtonText,
        labelText: this.labelText,
        accept: this.accept,
        uploadMode: this.uploadMode,
        activeStateEnabled: this.activeStateEnabled,
        allowCanceling: this.allowCanceling,
        chunkSize: this.chunkSize,
        disabled: this.disabled,
        focusStateEnabled: this.focusStateEnabled,
        hoverStateEnabled: this.hoverStateEnabled,
        isValid: this.isValid,
        maxFileSize: this.maxFileSize,
        minFileSize: this.minFileSize,
        multiple: this.multiple,
        name: this.name,
        invalidFileExtensionMessage: this.invalidFileExtensionMessage,
        invalidMaxFileSizeMessage: this.invalidMaxFileSizeMessage,
        invalidMinFileSizeMessage: this.invalidMinFileSizeMessage,
        readOnly: this.readOnly,
        readyToUploadMessage: this.readyToUploadMessage,
        rtlEnabled: this.rtlEnabled,
        showFileList: this.showFileList,
        tabIndex: this.tabIndex,
        uploadButtonText: this.uploadButtonText,
        uploadedMessage: this.uploadedMessage,
        uploadFailedMessage: this.uploadFailedMessage,
        uploadMethod: this.uploadMethod,
        uploadUrl: this.uploadUrl,
        validationStatus: this.validationStatus,
        value: this.value,
        visible: this.visible,
        dropZone: this.dropZone,
        allowedFileExtensions: this.allowedFileExtensions,
        dialogTrigger: this.dialogTrigger,
        setFileUploaderStyle: (_fileUploaderStyle) => (_fileUploaderStyle = style),
      };
    }
  }

  imgUploaded(ev) {
    this.onImgUploaded.emit(ev);
  }

  fileUploaded(ev) {
    this.onFileUploaded.emit(ev);
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: AddEventListenerOptions
  ): void {
    this.eventListener.push({ type, listener });
  }
}
